import { render, staticRenderFns } from "./EditExpenseCategoryModal.vue?vue&type=template&id=20d3fb62&scoped=true"
import script from "./EditExpenseCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditExpenseCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./EditExpenseCategoryModal.vue?vue&type=style&index=0&id=20d3fb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3fb62",
  null
  
)

export default component.exports